export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            有资源需求或合作意向？欢迎与我们联系
          </p>
        </div>
        <div className="bg-gradient-to-br from-background-100 to-background-200/50 border border-background-200/70 rounded-2xl p-6 md:p-10">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-8 text-center">
            有资源需求或合作意向？欢迎通过以下方式联系我们。我们重视每一位用户的反馈，将持续优化平台体验，为您提供更好的观影服务。
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
            <div className="flex flex-col items-center p-4 rounded-xl bg-background-50 border border-background-200/50">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <span className="text-xs text-foreground-500 mb-1">商务合作</span>
              <span className="text-sm font-medium text-foreground-900">cooperation@mahua.tv</span>
            </div>
            <div className="flex flex-col items-center p-4 rounded-xl bg-background-50 border border-background-200/50">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 mb-3">
                <i className="ri-chat-3-line text-lg"></i>
              </div>
              <span className="text-xs text-foreground-500 mb-1">用户反馈</span>
              <span className="text-sm font-medium text-foreground-900">feedback@mahua.tv</span>
            </div>
            <div className="flex flex-col items-center p-4 rounded-xl bg-background-50 border border-background-200/50">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 mb-3">
                <i className="ri-team-line text-lg"></i>
              </div>
              <span className="text-xs text-foreground-500 mb-1">资源投稿</span>
              <span className="text-sm font-medium text-foreground-900">submit@mahua.tv</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}